import { formatCarrierPaymentMethod } from 'shared/helpers/CarrierPaymentTypes';
import { SuperPayLabel } from 'shared/helpers/PaymentHelpers';
import { LoadDTO } from '../data/LoadDTO';
import { ViewLoadPaymentCardRow } from './ViewLoadPaymentRenderCardRow';

interface PaymentMethodProps {
  load: LoadDTO;
}

const defaultValuePlaceholder = 'No details';

export function ViewLoadPaymentMethod({ load }: PaymentMethodProps) {
  return (
    <ViewLoadPaymentCardRow
      title="Method"
      e2eValue="payment.payment_method"
      value={
        load.payment_details?.payment_method === 'superpay' ? (
          <SuperPayLabel source="Load Details" />
        ) : load.customer_payment?.payment_method ? (
          formatCarrierPaymentMethod(load.customer_payment.payment_method)
        ) : load.payment_details?.payment_method ? (
          formatCarrierPaymentMethod(load.payment_details.payment_method)
        ) : (
          defaultValuePlaceholder
        )
      }
    />
  );
}

export function ViewLoadPaymentOriginalMethod({ load }: PaymentMethodProps) {
  const [payment] = load.payments || [];

  return (
    <ViewLoadPaymentCardRow
      title="Original Method"
      e2eValue="payment.original_method"
      value={
        payment?.original_method === 'superpay' ? (
          <SuperPayLabel source="Load Details" />
        ) : load.subhauler_payment?.payment_method ? (
          formatCarrierPaymentMethod(load.subhauler_payment.payment_method)
        ) : payment?.original_method ? (
          formatCarrierPaymentMethod(payment?.original_method)
        ) : (
          defaultValuePlaceholder
        )
      }
    />
  );
}
